import { gql } from "@apollo/client";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2"
import { isEqual } from "lodash";
import { useState } from "react";
import { useUpdateProgramMutation } from "~/graphql/__generated__/graphql";

import { Program, useOrgConfig } from "~/providers/OrgConfigProvider";

type Props = {
  program: Program,
};


const ConfigureProgram = ({ program }: Props) => {
  const [local, setLocal] = useState<Program>(program);
  const [updateProgram, { loading }] = useUpdateProgramMutation();
  const { serviceLines } = useOrgConfig();

  const noLocalChanges = isEqual(program, local);

  const onSave = async () => {
    await updateProgram({
      variables: {
        programId: program.id,
        name: local.name,
        serviceLineId: local.serviceLineId,
      },
      awaitRefetchQueries: true,
      refetchQueries: ["OrgConfig"],
    });
  };

  return <Card sx={{ height: "100%", pl: 1 }}>
    <CardContent>
      <Grid container sx={{ alignItems: "center" }} spacing={2}>
        <Grid size={{ xs: 12, md: 4, lg: 3, xl: 2 }}>
          Program Name
        </Grid>
        <Grid  size={{ xs: 12, md: 8, lg: 9, xl: 10 }}>
          <TextField
            size="small"
            sx={{ width: "16em" }}
            value={local.name}
            onChange={e => setLocal({ ...local, name: e.target.value })}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4, lg: 3, xl: 2 }}>
          Service Line
        </Grid>
        <Grid  size={{ xs: 12, md: 8, lg: 9, xl: 10 }}>
          <Select
            margin="dense"
            sx={{ width: "16em" }}
            value={local.serviceLineId}
            onChange={(e) => setLocal({ ...local, serviceLineId: Number(e.target.value) })}
            disabled={loading}
          >
            {Object.values(serviceLines).map(sl => sl && <MenuItem key={sl.id} value={sl.id}>{sl.name}</MenuItem>)}
          </Select>
        </Grid>
      </Grid>
    </CardContent>
    <CardActions>
      <Button variant="contained" size="small" color="primary" disabled={noLocalChanges} onClick={onSave} loading={loading}>
        Save
      </Button>
      <Button variant="outlined" size="small" color="secondary" disabled={loading} onClick={() => setLocal(program)}>
        Reset
      </Button>
    </CardActions>
  </Card>
}

export default ConfigureProgram;

gql(`
  mutation UpdateProgram(
    $programId: Int!
    $name: String!
    $serviceLineId: Int!
  )
  @permission(requires: manageOrgConfig)
  {
    updateProgram(
      id: $programId
      name: $name
      serviceLineId: $serviceLineId
    ) {
      id
      name
    }
  }
`);
